import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { checkValidForm } from './Step1';
import { useEffect } from 'react';
import BtnSave from './BtnSave';

const Step6 = (props) => {
    const { t } = useTranslation();

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep6(true);
            })
            .catch(() => props.setStep6(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.dpo) {
            onValuesChange(null, props.previewData?.dpo);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = ['dpoNameTh'];
        const check = checkValidForm(fields, allValues);
        props.setStep6(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des6')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="dpo"
                layout="vertical"
                form={props?.form}
            >
                <Form.Item
                    className="mt-4"
                    name={'dpoNameTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.dpoNameTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'dpoNameEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.dpoNameEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodEnPl')}
                    />
                </Form.Item>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step6;
